<template>
  <!-- <div class="create">
    <div class="container">
      <div class="card">
        <form class="col s12" @submit.prevent="uploadProject">
          <div class="row">
            <div class="form__group field">
              <input
                type="text"
                class="form__field"
                placeholder="Title"
                name="title"
                id="title"
                required
                v-model="title"
              />
              <label for="name" class="form__label">Title</label>
            </div>
            <div class="form__group field">
              <input
                type="link"
                class="form__field"
                placeholder="Link"
                id="link"
                required
                v-model="link"
              />
              <label for="Email" class="form__label">Link</label>
            </div>
            <div class="form__group field">
              <input
                type="file"
                class="form__field"
                placeholder="file"
                id="file"
                required
                accept="image/*"
                @change="loadImage"
              />
            </div>
            <input type="submit" class="btn form" value="Submit" name="" />
          </div>
        </form>
      </div>
    </div>
  </div> -->
  <div class="foming">
    <div class="container">
      <h6>Create a project</h6>

      <div class="row">
        <div class="col s12 m3 l3"></div>
        <div class="col s12 m6 l6">
          <div class="formarea">
            <form class="col s12" @submit.prevent="uploadProject">
              <div class="row">
                <div class="form__group field">
                  <input
                    type="text"
                    class="form__field"
                    placeholder="Title"
                    name="name"
                    id="name"
                    required
                    v-model="title"
                  />
                  <label for="name" class="form__label">Title</label>
                </div>
                <div class="form__group field">
                  <input
                    type="text"
                    class="form__field"
                    placeholder="Link"
                    id="Email"
                    required
                    v-model="link"
                  />
                  <label for="Email" class="form__label">Link</label>
                </div>
                <div class="form__group field">
                  <input
                    ref="uploader"
                    type="file"
                    class="form__field"
                    placeholder="file"
                    id="file"
                    required
                    accept="image/*"
                    @change="loadImage"
                  />

                  <label for="Email" class="form__label">Avatar</label>
                </div>
                <input type="submit" class="btn form" value="upload" name="" />
              </div>
            </form>
          </div>
        </div>
        <div class="col s12 m3 l3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const link = ref("");
    const date = ref(new Date().toISOString());
    const title = ref("");
    const file = ref("");
    const uploadProject = () => {
      store.dispatch("addProject", {
        file: file.value,
        title: title.value,
        date: date.value,
        link: link.value,
      });
    };
    const loadImage = (e) => {
      file.value = e.target.files[0];
    };

    return {
      uploadProject,
      title,
      link,
      loadImage,
    };
  },
};
</script>

<style lang="scss" scoped>
h6 {
  padding: 10px;
}
// new
.foming {
  min-height: 100vh;
  margin-top: 55px;
}
.title {
  text-align: center;
  text-transform: capitalize;
  font-size: 22px;
  font-weight: 600;
}
.formarea {
  // margin-top: 30vh;
}
.form__group {
  position: relative;
  padding: 12px 0 0;
  margin-top: 4px;
  width: 100%;
}

.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid black !important;
  outline: 0;
  font-size: 14px;
  color: black;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;

  &::placeholder {
    color: transparent;
  }

  &:placeholder-shown ~ .form__label {
    font-size: 14px;
    cursor: text;
    top: 20px;
  }
}
.form {
  background-color: #765cd1;
  width: 100%;
  margin-top: 20px;
}

.form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 1rem;
  color: black !important;
}

.form__field:focus {
  ~ .form__label {
    position: absolute;
    top: 0;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #765cd1 !important;
    font-weight: 700;
  }
  padding-bottom: 6px;
  font-weight: 700;
  border-width: 3px;
  border-image: linear-gradient(to right, #765cd1, #765cd1);
  border-image-slice: 1;
}
/* reset input */
.form__field {
  &:required,
  &:invalid {
    box-shadow: none;
  }
}
</style>
